import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG, EnvironmentConfig } from 'src/app/core/enviroment-config';
import { SendApiService } from 'src/app/core/service/abstract/send-api.service';
import { ServiceOrder } from 'src/app/data/model/service-order';
import { ApiModule } from '../api.module';

@Injectable({
  providedIn: ApiModule,
})
export class SendOrderApiService extends SendApiService {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('resources/send-order', http, config);
  }
}
